import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
import { RECS, VERDICT_TONE } from '../../lib/roomApi';
import { Pill } from '../aiinterview/recruiter/common';

const REC = Object.fromEntries(RECS.map(([k, l, t]) => [k, { l, t }]));

export const PanelStatus = ({ panel }) => (
  <div className="iv-row" style={{ gap: '0.5rem' }} data-testid="scorecard-panel-status">
    {panel.map((m) => (
      <span key={m.id} className="iv-small iv-row" style={{ gap: '0.25rem' }} data-testid={`scorecard-member-${m.id}`}>
        {m.submitted ? <CheckCircle2 size={14} color="#047857" /> : <Circle size={14} />}{m.name || 'Interviewer'}
      </span>
    ))}
  </div>
);

export const VerdictCard = ({ v }) => (
  <div className="vr-verdict" data-testid="scorecard-verdict">
    <div>
      <small>Panel verdict</small>
      <div className="vr-verdict-label" data-testid="scorecard-verdict-label">{v.label}</div>
      <small>{v.score_avg != null ? `Average ${v.score_avg}/5` : 'No scores'} · {Object.entries(v.tally).filter(([, n]) => n).map(([k, n]) => `${n} ${REC[k].l}`).join(', ')}</small>
    </div>
    <Pill tone={VERDICT_TONE[v.label] || 'slate'}>{v.label}</Pill>
    {v.flags.length > 0 && <ul className="vr-list" style={{ flexBasis: '100%', color: '#FCD34D' }}>{v.flags.map((f) => <li key={f}>{f}</li>)}</ul>}
    <div className="vr-verdict-grid">
      {v.competencies.map((c) => (
        <div key={c.competency} className="vr-verdict-row">
          <span>{c.competency}{c.must_have ? ' *' : ''}</span>
          <b>{c.avg ?? '—'}</b>
          <span className="vr-muted">{c.n ? `${c.min}–${c.max}` : 'not rated'}{c.split ? ' · split' : ''}</span>
        </div>
      ))}
    </div>
  </div>
);

export const CardView = ({ card, comps }) => (
  <details className="vr-card-view" data-testid={`scorecard-view-${card.user_id}`}>
    <summary>
      <b>{card.user_name}</b>
      {card.recommendation && <Pill tone={REC[card.recommendation].t}>{REC[card.recommendation].l}</Pill>}
    </summary>
    {comps.map((c) => {
      const r = card.ratings[c.name] || {};
      return <div key={c.name} className="iv-hist iv-small"><span>{c.name}</span><b>{r.score ? `${r.score}/5` : 'Not assessed'}{r.note ? ` · ${r.note}` : ''}</b></div>;
    })}
    {card.notes && <p className="iv-small" style={{ marginTop: '0.4rem', whiteSpace: 'pre-wrap' }}>{card.notes}</p>}
  </details>
);
